import "./index.scss";

import _ from "lodash";
import { Component, Prop, Vue } from "vue-property-decorator";

import IconSvg from "@/components/Icon-svg";
import { prevent } from "@/shared/utils/prevent";

@Component({
  name: "Check",
})
export default class Check extends Vue {
  @Prop({ default: false })
  private value!: boolean;

  @Prop({ default: "checkbox" })
  private mode!: string;

  @Prop({ default: "#aaa" })
  private borderColor!: string;

  @Prop({ default: "#09f" })
  private fillColor!: string;

  @Prop({ default: 14 })
  private size!: number;

  @Prop({ default: "white" })
  private checkColor!: string;

  @Prop({ default: false })
  private parentClick!: boolean;

  @Prop({ default: false })
  private disable!: boolean;

  @Prop({ default: "#eee" })
  private disableColor!: string;

  mounted() {
    this.parentClick &&
      this.$el.parentElement!.addEventListener("click", () => this.toggle());
  }

  beforeDestroy() {
    this.parentClick &&
      this.$el.parentElement &&
      this.$el.parentElement.removeEventListener("click", () => this.toggle());
  }

  get baseStyle() {
    return {
      width: `${this.size}px`,
      height: `${this.size}px`,
      border: "1px solid",
      borderColor: this.borderColor,
    };
  }

  get modeStyle() {
    return this.mode === "radio"
      ? {
          borderRadius: "50%",
        }
      : {};
  }

  get checkStyle() {
    return this.checked
      ? {
          background: this.fillColor,
          borderColor: this.fillColor,
          lineHeight: `${this.size - 2}px`,
        }
      : {
          background: this.disable ? this.disableColor : "",
        };
  }

  get checkIconStyle() {
    return {
      color: this.checkColor,
      visibility: this.checked ? "visible" : "hidden",
    };
  }

  get checked() {
    return this.value;
  }

  set checked(val: boolean) {
    this.$emit("input", val);
    this.$emit("change", val);
  }

  toggle(e?: Event) {
    if (!this.disable) {
      this.checked = !this.checked;
    }
    e && prevent(e);
  }

  render() {
    return (
      <div class="Check" onClick={(e: Event) => this.toggle(e)}>
        <div
          class="Check__icon"
          style={[this.baseStyle, this.modeStyle, this.checkStyle]}
        >
          <IconSvg
            class="Check__icon-check"
            iconClass="check"
            style={this.checkIconStyle}
          />
        </div>
      </div>
    );
  }
}
